import { Tier } from "@/components/analytics/tier-badge";
import { paidFeaturesLive } from "@/lib/tier-blocking";
import { cn } from "@/lib/utils";
import { Lock } from "lucide-react";
import { Button } from "../ui/button";

export function LockedCardOverlay({
  tier,
  presentationId,
  bare = false,
  heading = "Unlock every metric in your workspace.",
  className,
}: {
  tier: Tier;
  presentationId?: string | null;
  bare?: boolean;
  heading?: string;
  className?: string;
}) {
  if (!paidFeaturesLive()) return null;

  const label = tier === "premium" ? "Premium" : "Advanced";
  const eyebrow = tier === "premium" ? "Premium plan" : "Advanced plan";
  const upgradeHref = presentationId
    ? `/dashboard/presentations/${presentationId}/settings`
    : "/dashboard/billing";

  return (
    <div
      className={cn(
        "absolute inset-0 z-20 flex flex-col justify-between overflow-hidden rounded-md bg-background/75 backdrop-blur-xs",
        bare ? "p-3" : "p-4",
        bare && "pointer-events-none",
        className,
      )}
    >
      <div
        className={cn(
          "flex items-start justify-between gap-3 w-full",
          bare && "pointer-events-auto",
        )}
      >
        <span className="text-xs tracking-widest text-muted-foreground">
          {eyebrow}
        </span>
        <Button
          className="group flex items-center gap-0 hover:gap-2 overflow-hidden bg-card p-2 rounded-md border border-border"
          variant="outline"
          size="sm"
          onClick={() => {
            window.location.href = upgradeHref;
          }}
        >
          <div className="grid group-hover:grid-cols-[1fr] grid-cols-[0fr] transition-all text-xs duration-300">
            <span className="overflow-hidden whitespace-nowrap">
              Unlock {label}
            </span>
          </div>
          <Lock className="size-3 text-muted-foreground group-hover:text-neutral-700 dark:group-hover:text-foreground/80 transition-colors duration-300 shrink-0" />
        </Button>
      </div>

      <div className="flex flex-col gap-3">
        <h5
          className={cn(
            "font-medium text-neutral-900 dark:text-foreground leading-tight tracking-tight",
            bare ? "text-sm max-w-[24ch]" : "text-2xl max-w-[16ch]",
          )}
        >
          {heading}
        </h5>
        {!bare && (
          <div className="flex flex-row items-center gap-2">
            <Button
              size="xs"
              className="font-medium"
              onClick={() => {
                window.location.href = upgradeHref;
              }}
            >
              Upgrade
            </Button>
            <Button
              size="xs"
              variant="ghost"
              className="font-medium text-neutral-600 dark:text-muted-foreground hover:text-neutral-900 dark:hover:text-foreground"
              onClick={() => {
                window.location.href = "/pricing";
              }}
            >
              See what's included →
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
